import React, { useEffect, useState } from "react";
import { useSettings } from '../SettingsContext';

const OurSuccess = () => {
    const setting = useSettings();
    const [cachedSettings, setCachedSettings] = useState(null);
    const [fontSize, setFontSize] = useState('40px');

    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        const cachedData = JSON.parse(localStorage.getItem('settingsData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                setCachedSettings(data);
            } else {
                localStorage.removeItem('settingsData');
                updateSettingsCache();
            }
        } else {
            updateSettingsCache();
        }
    }, [setting]);

    const updateSettingsCache = () => {
        if (setting) {
            const settingsData = {
                data: setting,
                timestamp: Date.now(),
            };
            localStorage.setItem('settingsData', JSON.stringify(settingsData));
            setCachedSettings(setting);
        }
    };

    // Responsive font-size logic
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 1024) {
                setFontSize('40px');
            } else if (width >= 768) {
                setFontSize('30px');
            } else {
                setFontSize('25px');
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const statsData = [
        { value: cachedSettings?.working_type || "22+", label: "YEARS EXPERIENCE" },
        { value: cachedSettings?.visa_consulting || "10K+", label: "WORKERS DEPLOYED" },
        { value: cachedSettings?.happy_client || "11+", label: "COUNTRIES SERVED" },
        { value: cachedSettings?.win_awards || "75+", label: "EXPERT CONSULTANTS" }
    ];

    return (
        <section
            className="fact-area position-relative overflow-hidden"
            style={{
                backgroundImage: 'url("55.png")',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundColor: '#ffffff',
                paddingTop: '80px',
                paddingBottom: '80px'
            }}
        >
            <div className="container px-1 position-relative" style={{ zIndex: 2 }}>
                {/* Section Title */}
                <div className="row mb-5">
                    <div className="col-12">
                        <h2 className="fw-bold mb-2" style={{ color: '#0f172a' }}>Key Track Record & Growth</h2>
                        <div className="divider" style={{ width: '60px', height: '4px', backgroundColor: '#2563eb', borderRadius: '2px' }}></div>
                    </div>
                </div>

                {/* 4 Clean Glassmorphism Cards */}
                <div className="row g-4 align-items-center justify-content-center">
                    {statsData.map((item, index) => (
                        <div key={index} className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div
                                className="fact text-center p-4 h-100"
                                style={{
                                    borderRadius: '16px',
                                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                    backdropFilter: 'blur(5px)',
                                    border: '1px solid rgba(255, 255, 255, 0.8)',
                                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.08)'
                                }}
                            >
                                <h1 className="counter-count mb-1">
                                    <span className="counter fw-bold" style={{ fontSize, color: '#1e3a8a' }}>
                                        {item.value}
                                    </span>
                                </h1>
                                <span className="fw-bold text-muted" style={{ fontSize: '13px', letterSpacing: '0.5px' }}>
                                    {item.label}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default OurSuccess;